// @flow
export const ABSENTEE_BID_FAILURE = 'la/ui/absenteeBid/FAILURE';
export const ABSENTEE_BID_REQUEST = 'la/ui/absenteeBid/REQUEST';
export const ABSENTEE_BID_SUCCESS = 'la/ui/absenteeBid/SUCCESS';

export const LOAD_SECONDARY_CATEGORY_RESULTS_FAIL = 'LOAD_SECONDARY_CATEGORY_RESULTS_FAIL';
export const LOAD_SECONDARY_CATEGORY_RESULTS_REQUEST = 'LOAD_SECONDARY_CATEGORY_RESULTS_REQUEST';
export const LOAD_SECONDARY_CATEGORY_RESULTS_SUCCESS = 'LOAD_SECONDARY_CATEGORY_RESULTS_SUCCESS';

export const LOAD_SECONDARY_SEARCH_RESULTS_FAIL = 'LOAD_SECONDARY_SEARCH_RESULTS_FAIL';
export const LOAD_SECONDARY_SEARCH_RESULTS_REQUEST = 'LOAD_SECONDARY_SEARCH_RESULTS_REQUEST';
export const LOAD_SECONDARY_SEARCH_RESULTS_SUCCESS = 'LOAD_SECONDARY_SEARCH_RESULTS_SUCCESS';

export const PUBNUB_GLOBAL_NOTIFICATION_RECEIVED = 'la/domain/globalNotification/PUBNUB_GLOBAL_NOTIFICATION_RECEIVED';
